/* eslint-disable import/prefer-default-export */
export const getSuppliers = state => state.suppliers
